import React, { useEffect, useState } from 'react';

const COPY = {
  en: {
    dirty: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save changes',
    saving: 'Saving…',
    saved: 'Saved',
  },
  zh: {
    dirty: '有未保存的修改',
    discard: '放弃',
    save: '保存修改',
    saving: '保存中…',
    saved: '已保存',
  },
};

function ProfileSaveBar({ lang, visible, saving, justSaved, onSave, onDiscard }) {
  const t = COPY[lang === 'zh' ? 'zh' : 'en'];
  const [showSaved, setShowSaved] = useState(false);

  useEffect(() => {
    if (!justSaved) return undefined;
    setShowSaved(true);
    const timer = setTimeout(() => setShowSaved(false), 1600);
    return () => clearTimeout(timer);
  }, [justSaved]);

  if (!visible && !showSaved) return null;

  return (
    <div
      className={`profile-v2-save-bar${visible || showSaved ? ' is-visible' : ''}`}
      role="region"
      aria-live="polite"
      aria-label={t.dirty}
    >
      <div className="profile-v2-save-bar-inner">
        {showSaved ? (
          <span className="profile-v2-save-bar-status profile-v2-save-bar-saved">
            <span className="profile-v2-check" aria-hidden="true">✓</span>
            {t.saved}
          </span>
        ) : (
          <>
            <span className="profile-v2-save-bar-status">
              <span className="profile-v2-dirty-dot" aria-hidden="true" />
              {t.dirty}
            </span>
            <div className="profile-v2-save-bar-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={onDiscard}
                disabled={saving}
              >
                {t.discard}
              </button>
              <button type="button" onClick={onSave} disabled={saving}>
                {saving ? t.saving : t.save}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ProfileSaveBar;
